import { z } from 'zod';

import type { UpdateUserPayload } from '@/interfaces/user';

export const UpdateUserValidation: z.ZodType<UpdateUserPayload> = z.object({
  userName: z.string().max(280).optional(),
  description: z.string().optional(),
  dateOfBirth: z.date().optional(),
});
